import React, { useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";

import FAQs from '../../Modal_Components/Faq';
import FloatingModal from '../Modals/Floating_Modal';

import styles from './Nav.module.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

const IntroNav = ({ location }) => {
  const { loginWithRedirect } = useAuth0();
  const [activeLink, setActiveLink] = useState("#home");
  const [showFaqs, setShowFaqs] = useState(false);

  const handleSelect = (eventKey) => {
    setActiveLink(eventKey);
  };

  const handleSignup = () => {
    loginWithRedirect({
      authorizationParams: { screen_hint: 'signup',},
    })
  };

  const handleCloseFaqs = () => setShowFaqs(false);

  const joinButton = () => {
    return <button className="secondaryBtn" onClick={() => handleSignup()}>Sign Up</button>
  }

  // const mobileAppLink = () => {
  //   return (
  //     <div className={`pt-1 d-flex justify-content-left align-items-left`}>
  //       <a href='https://apps.apple.com/us/app/myschedulepal/id6745926865' target='_blank' className="ctaSecondaryBtn">Download the App</a>
  //     </div>
  //   );
  // }

  const mobileAppLink = () => {
    return (
      <div className="d-flex flex-column flex-md-row justify-content-start justify-content-md-center gap-4 align-items-center pt-2 pb-1">
        <a href="https://apps.apple.com/us/app/myschedulepal/id6745926865" target="_blank" rel="noreferrer" aria-label="Download on the App Store">
          <img src="/assets/icons/appstore_btn.svg" alt="App Store" style={{ height: 54 }} />
        </a>

        <a href="https://play.google.com/store/apps/details?id=com.myschedulepal.mspmobile&hl=en_US" target="_blank" rel="noreferrer" aria-label="Download on the Google Play Store">
          <img src="/assets/images/googleplay_btn.png" alt="Google Play" style={{ height: 54 }} />
        </a>
      </div>
    );
  }

  return (
    <Navbar collapseOnSelect expand="lg" className={styles.navbar}>
      <Container>
        <Navbar.Brand className={styles.custNavbarBrand} href="#home">
          <img
            alt=""
            src="/assets/images/app_icon_512.png"
            width="30"
            height="30"
            className="d-inline-block align-top"
            style={{ borderRadius: "6px" }}
          />{' '}
          MySchedulePal
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto" activeKey={activeLink} onSelect={handleSelect}>
            <Nav.Link 
              href="#features" 
              eventKey="#features" 
              className={`${styles.navLink} ${activeLink === "#features" ? styles.navLinkActive : ""}`}
            >
              Features
            </Nav.Link>
            <Nav.Link 
              href="#hipaa" 
              eventKey="#hipaa" 
              className={`${styles.navLink} ${activeLink === "#hipaa" ? styles.navLinkActive : ""}`}
            >
              HIPAA
            </Nav.Link>
            <Nav.Link 
              href="#pricing" 
              eventKey="#pricing" 
              className={`${styles.navLink} ${activeLink === "#pricing" ? styles.navLinkActive : ""}`}
            >
              Pricing
            </Nav.Link> 
            <Nav.Link 
              onClick={() => setShowFaqs(true)}
              eventKey="#faq" 
              className={`${styles.navLink} ${activeLink === "#faq" ? styles.navLinkActive : ""}`}
            >
              FAQs
            </Nav.Link>           
          </Nav>
          <Nav activeKey={activeLink} onSelect={handleSelect}>
            {mobileAppLink()}
          </Nav>
        </Navbar.Collapse>
      </Container>
      <FloatingModal 
        title="FAQs" 
        component={<FAQs />} 
        show={showFaqs} 
        handleClose={handleCloseFaqs}
      />
    </Navbar>
  );
}

export default IntroNav;

